import { useCallback } from "react"
import { useFormContext } from "react-hook-form"
import { useBetterDocSuggestionsStoreContext } from "@/modules/patients/detail/better-doc/store/useBetterDocSuggestionsStore"
import { useProgressNoteFormContext } from "@/modules/patients/detail/progress-note/hooks/useProgressNoteFormStore"
import { PointOfCareFormType } from "@/modules/patients/detail/progress-note/point-of-care/schema"
import { EpisodeOfCareProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"

type UseClearSelectedCareProviderParams = {
  episodeOfCareProgressNoteData?: EpisodeOfCareProgressNoteData
  setCareProvider?: (careProvider: string | null) => void
}

export const useClearSelectedCareProvider = ({
  episodeOfCareProgressNoteData,
  setCareProvider,
}: UseClearSelectedCareProviderParams): (() => void) => {
  const { setValue } = useFormContext<PointOfCareFormType>()
  const clearBetterDocReferralLetterErrors = useProgressNoteFormContext(
    (state) => state.clearBetterDocReferralLetterErrors,
  )
  const onReset = useBetterDocSuggestionsStoreContext((store) => store.onReset)
  const progressNoteId = episodeOfCareProgressNoteData?.id

  return useCallback(() => {
    setValue("careProviderId", null, { shouldDirty: true, shouldValidate: true })
    setValue("isBetterDocSuggestion", false, { shouldDirty: true })
    setValue("betterDocSuggestionStatus", null)
    onReset(progressNoteId)
    setCareProvider?.(null)
    if (progressNoteId) {
      clearBetterDocReferralLetterErrors(progressNoteId)
    }
  }, [clearBetterDocReferralLetterErrors, onReset, progressNoteId, setCareProvider, setValue])
}
